import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

import { SentryRoutes } from '../utils/sentry';

import PublicLayout from '../layouts/public';
import TriageLayout from '../layouts/triage';
import SDMLayout from '../layouts/sdm';
import ToolTip from '../components/tooltip';

const App = () => (
    <Suspense fallback={<div />}>
        <ToolTip id="tooltip" />
        <SentryRoutes>
            <Route path="/triage/*" element={<TriageLayout />} />
            <Route path="/sdm/*" element={<SDMLayout />} />
            <Route path="/*" element={<PublicLayout />} />
        </SentryRoutes>
    </Suspense>
);

export default App;
